import _ from 'lodash'
import * as linkify from 'linkifyjs'
import linkifyElement from 'linkifyjs/element'
import mention from 'linkifyjs/plugins/mention'
mention(linkify)

export default {
  props: {
    isOtherMessage: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    let linkClasses = ['link']
    if(this.isOtherMessage) {
      linkClasses.push('otherMessage')
    }
    if (this.$refs['message-content']) {
      linkifyElement(this.$refs['message-content'],
        {
          className: function(href, type) {
            if(type === 'mention') {
              linkClasses.push('mention')
            }
            return _.join(linkClasses, ' ')
          }
        }
        , document)
    }
  }
}
